import { useCallback } from 'react';
import {
  trackCTAClick,
  trackVideoEvent,
  trackFormEvent,
  trackScrollEvent,
  trackNavigation,
  trackUserAction,
  trackConversion,
  trackError,
  trackTimeOnPage,
  setCustomVariable,
  setUserInfo
} from '../config/gtm';

// Hook personalizado para Google Tag Manager
const useGTM = () => {
  // Función para trackear clicks en CTAs
  const trackCTA = useCallback((ctaName, section, ctaType = 'button') => {
    trackCTAClick(ctaName, section, ctaType);
  }, []);

  // Función para trackear eventos de video
  const trackVideo = useCallback((action, videoName, section, progress = null) => {
    trackVideoEvent(action, videoName, section, progress);
  }, []);

  // Función para trackear eventos de formulario
  const trackForm = useCallback((action, formName, formType = 'contact') => {
    trackFormEvent(action, formName, formType);
  }, []);

  // Función para trackear scroll
  const trackScroll = useCallback((scrollDepth) => {
    trackScrollEvent(scrollDepth);
  }, []);

  // Función para trackear navegación
  const trackNav = useCallback((destination, navigationType = 'internal') => {
    trackNavigation(destination, navigationType);
  }, []);

  // Función para trackear acciones de usuario
  const trackAction = useCallback((action, category, label, value = null) => {
    trackUserAction(action, category, label, value);
  }, []);

  // Función para trackear conversiones
  const trackConv = useCallback((conversionType, conversionValue = null, currency = 'USD') => {
    trackConversion(conversionType, conversionValue, currency);
  }, []);

  // Función para trackear errores
  const trackErr = useCallback((errorType, errorMessage, errorLocation) => {
    trackError(errorType, errorMessage, errorLocation);
  }, []);

  // Función para trackear tiempo en página
  const trackTime = useCallback((timeSpent) => {
    trackTimeOnPage(timeSpent);
  }, []);

  // Función para configurar variables personalizadas
  const setVariable = useCallback((key, value) => {
    setCustomVariable(key, value);
  }, []);

  // Función para configurar información del usuario
  const setUser = useCallback((userId, userType = 'visitor') => {
    setUserInfo(userId, userType);
  }, []);

  return {
    trackCTA,
    trackVideo,
    trackForm,
    trackScroll,
    trackNav,
    trackAction,
    trackConv,
    trackErr,
    trackTime,
    setVariable,
    setUser
  };
};

export default useGTM;
